import { IAttribute, IModel } from '../base/annotation';
import { Metamodel } from '../base/model';
import { ParameterConfig } from './parameter-config';

@Metamodel.model({})
export class ExecuteSSISPackagePropertyOverrideConfig extends ParameterConfig {
    public static readonly MODEL: IModel;
    public static readonly VALUE: IAttribute;
    public static readonly SENSITIVE: IAttribute;

    @Metamodel.attribute({
        association: 'SENSITIVE'
    })
    public sensitive: boolean;

    public fromJson: boolean = false;

}
